import { Injectable } from '@angular/core';
import { Route, UrlSegment, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { StorageHelper } from '../../../_helpers';

@Injectable({
    providedIn: 'root'
})
export class MpinGuard  {

    constructor(
        private router: Router
    ) { }

    canActivate(
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        return this.isValid();
    }
    canLoad(
        route: Route,
        segments: UrlSegment[]): Observable<boolean> | Promise<boolean> | boolean {
        return this.isValid();
    }

    /**
     * If once MPIN is entered by User, On refreashing app user must enter MPIN.
     * Login page is prevented if MPIN is enabled.
     *
     * @returns true if MPIN is not set. Else False.
     */
    isValid() {
        // Pages Prevented if Two fa is enabled. (Ex :- Login Page)
        if (StorageHelper.TwoFAToken) {
            this.router.navigate(['/auth/twoFA']);
            return false;
        }
        return true;
    }
}
